import { InvitationResource } from '../../Store/Types';
import { findLink } from '../../../../../../LinkyLinky';
import ModalStore from '../../../../../Modal/Store';
import { T } from '../../../../../../Translations';
import InvitationStore from '../../Store/InvitationStore';
import { Maybe } from 'maybeasy';

interface Props {
  store: InvitationStore;
  resource: InvitationResource;
  modalStore: ModalStore;
}

export const reactivateLink = ({ store, resource, modalStore }: Props): Maybe<React.ReactNode> => {
  const handleClick = () => {
    store.reactivating(resource);
    modalStore.open();
  };

  return findLink('reactivate', resource.links).map((_link) => (
    <span className="px-2.5 py-4 cursor-pointer" onClick={handleClick}>
      <T kind="Restore Collection Access" />
    </span>
  ));
};
